import React, { FC } from 'react';
import './WebUxLayout.less';
import { Space } from 'antd';

export const WebUxPage: FC = (props) => {
  return <div className="webux-page">{props.children}</div>;
};

export const WebUxPageContent: FC = (props) => {
  return (
    <div className="webux-page-content">
      <Space size={16} direction={'vertical'}>
        {props.children}
      </Space>
    </div>
  );
};

export const WebUxPageItem: FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
  return (
    <div {...props} className={`webux-page-item ${props.className ?? ''}`}>
      {props.children}
    </div>
  );
};
